import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-common-international-price',
    templateUrl: './common-international-price.component.html',
    styleUrls: ['./common-international-price.component.scss'],
    standalone: false
})
export class CommonInternationalPriceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
